import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 15.10.2026: каждый запрос к нашему API подписываем данными Telegram WebApp —
// бэкенд пускает только менеджеров, а часть страниц заголовок не передавала.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : input.url;
  const initData = window.Telegram?.WebApp?.initData;
  if (initData && url.includes('/api/')) {
    const headers = new Headers(init.headers || {});
    if (!headers.has('X-Telegram-Init-Data')) headers.set('X-Telegram-Init-Data', initData);
    init = { ...init, headers };
  }
  return nativeFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
